import { useFetch } from "~vue/api";
import { i18n } from "~vue/i18n";

export const COLLABORATION_PROFILE_BOOTSTRAP_ICON_CLASS = "bi-boxes";

export enum MainMenuPane {
    NEW_CHAT = "new_chat",
    HOME = "home",
    HISTORY = "history",
    GUIDED_SETUP = "guided_setup",
    PROFILE = "profile",
    COLLABORATION_PROFILE = "collaboration_profile",
    CONNECTIONS = "connections",
    PERFORMANCE_MANAGEMENT = "performance_management",
    MY_WORK = "my_work",
    JOURNEYS = "journeys",
    DEVELOPMENT_JOURNEYS = "development_journeys",
    MY_DEVELOPMENT = "my_development",
    COMPETENCY_ASSESSMENT = "competency_assessment",
    SCHNEIDER_ASSESSMENT = "schneider_assessment",
    REFLECTIONS = "reflections",
}

export type PaneNotificationCounts = Partial<Record<MainMenuPane, number>>;

export const ALL_PANES = Object.values(MainMenuPane);

export function paneNotificationAriaLabel(pane: MainMenuPane, label: string, count: number): string {
    if (count <= 0) {
        return label;
    }
    const { t } = i18n.global;
    const countLabel = pane === MainMenuPane.MY_WORK ? t("navigation.a11y.newInsights", { count }, count) : t("navigation.a11y.newNotifications", { count }, count);
    return t("navigation.a11y.paneWithCount", { label, countLabel });
}

/**
 * The server fills `privacy_link_label` with "Privacy" when the org has not customised it, so only
 * a real customisation wins over the catalogue.
 */
export function privacyRowLabel(customLabel: string | null | undefined): string {
    return customLabel && customLabel !== "Privacy" ? customLabel : i18n.global.t("navigation.privacy");
}

export async function validateDisabledPanes(disabledPanes: MainMenuPane[]) {
    try {
        const panesURI = globalThis.encodeURIComponent(disabledPanes.join(","));
        const { data, error } = await useFetch(`/v1/navigation/validate?panes=${panesURI}`).json<{ disabled_panes: MainMenuPane[] }>();

        if (!error.value && data.value) {
            const payload = data.value;
            return disabledPanes.filter((p) => payload.disabled_panes.includes(p));
        }

        throw new Error("Failed to validate disabled navigation panes");
    } catch {
        // "Failed to fetch" errors are expected when users navigate away or have network issues.
        // The function degrades gracefully by returning the original disabledPanes.
        return disabledPanes;
    }
}
